/* Shop4Seats — <s4s-pagination> (snippets/pagination). Deferred; loaded only where a grid has more than one page.
 * Mode per breakpoint (data-desktop / data-mobile): pages (links only), load_more (button), infinite (auto on scroll).
 * Loading: fetch the next page with ?section_id=, move the new grid's children into #data-grid, then take over the
 * fresh pager's next URL and count. Fires 's4s:cart-updated' so cards re-run fit lines / wishlist hearts. */
(() => {
  if (customElements.get('s4s-pagination')) return;
  const mq = matchMedia('(max-width: 989px)');

  class Pagination extends HTMLElement {
    connectedCallback() {
      this.btn = this.querySelector('[data-pager-more]');
      this.btn?.addEventListener('click', () => this.loadNext());
      this.observer = new IntersectionObserver((entries) => {
        if (entries.some((e) => e.isIntersecting) && this.mode() === 'infinite') this.loadNext();
      }, { rootMargin: '400px 0px' });
      if (this.btn) this.observer.observe(this.btn);
    }
    disconnectedCallback() { this.observer?.disconnect(); }

    mode() { return mq.matches ? this.dataset.mobile : this.dataset.desktop; }

    async loadNext() {
      if (this.busy || !this.dataset.next || this.mode() === 'pages') return;
      const grid = document.getElementById(this.dataset.grid);
      if (!grid) return;
      this.busy = true;
      S4S.busy(this.btn, true);
      try {
        const u = new URL(this.dataset.next, location.origin);
        u.searchParams.set('section_id', this.dataset.section);
        const doc = new DOMParser().parseFromString(await fetch(u).then((r) => r.text()), 'text/html');
        const fresh = doc.getElementById(this.dataset.grid);
        if (fresh) grid.append(...fresh.children);
        const pager = doc.querySelector('s4s-pagination');
        this.dataset.next = pager?.dataset.next || '';
        const shown = pager?.querySelector('[data-pager-shown]')?.textContent;
        if (shown) this.querySelector('[data-pager-shown]').textContent = shown;
        this.querySelector('.pager__more').hidden = !this.dataset.next;
        document.dispatchEvent(new CustomEvent('s4s:cart-updated'));
        if (window.S4S && S4S.syncWish) S4S.syncWish();
        grid.dispatchEvent(new CustomEvent('s4s:items-appended', { bubbles: true }));
      } catch (err) {
        location.href = this.dataset.next; // fall back to the normal page link
      } finally {
        this.busy = false;
        S4S.busy(this.btn, false);
      }
    }
  }
  customElements.define('s4s-pagination', Pagination);
})();
